// extracted by mini-css-extract-plugin
module.exports = {"embla__button":"EmblaCarouselArrowButtons_embla__button__MAMs2","embla__button__svg":"EmblaCarouselArrowButtons_embla__button__svg__b8WjB"};